import config from '~/config'

const { prefix, baseUrlDomain } = config.app

export const gleamerAppBaseUrl = prefix
  ? `${prefix}.${baseUrlDomain}`
  : `${baseUrlDomain}`
